import script from "./notation-editor.vue?vue&type=script&setup=true&lang=ts"
export * from "./notation-editor.vue?vue&type=script&setup=true&lang=ts"

import "./notation-editor.vue?vue&type=style&index=0&id=2c875035&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c875035"]])

export default __exports__